export enum BrokerSettingKeyType {
    Name = 'name',
    FieldType = 'fieldType',
    IsPassword = 'is_password',
    IsOptional = 'is_optional',
}

export enum BrokerLogo {
    shareIndia = '/assets/shareindialogowebp.webp',
    "5Paisa" = '/assets/5Paisa.png',
    kite = '/assets/kite.png',
    upStox = '/assets/upstox.png',
}